/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const IntesiResponseDtoTipoIdentificazioneEnum = {
    Spid: 'SPID',
    Cie: 'CIE',
    Self: 'SELF'
};
/**
 * Check if a given object implements the IntesiResponseDto interface.
 */
export function instanceOfIntesiResponseDto(value) {
    let isInstance = true;
    return isInstance;
}
export function IntesiResponseDtoFromJSON(json) {
    return IntesiResponseDtoFromJSONTyped(json, false);
}
export function IntesiResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idPratica': !exists(json, 'idPratica') ? undefined : json['idPratica'],
        'ticket': !exists(json, 'ticket') ? undefined : json['ticket'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'tipoIdentificazione': !exists(json, 'tipoIdentificazione') ? undefined : json['tipoIdentificazione'],
        'identifyUrl': !exists(json, 'identifyUrl') ? undefined : json['identifyUrl'],
        'registrationId': !exists(json, 'registrationId') ? undefined : json['registrationId'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'lastLogin': !exists(json, 'lastLogin') ? undefined : (new Date(json['lastLogin'])),
        'account': !exists(json, 'account') ? undefined : json['account'],
        'codicePratica': !exists(json, 'codicePratica') ? undefined : json['codicePratica'],
        'setSecurePin': !exists(json, 'setSecurePin') ? undefined : json['setSecurePin'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
    };
}
export function IntesiResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idPratica': value.idPratica,
        'ticket': value.ticket,
        'phoneNumber': value.phoneNumber,
        'tipoIdentificazione': value.tipoIdentificazione,
        'identifyUrl': value.identifyUrl,
        'registrationId': value.registrationId,
        'errorMessage': value.errorMessage,
        'lastLogin': value.lastLogin === undefined ? undefined : (value.lastLogin.toISOString()),
        'account': value.account,
        'codicePratica': value.codicePratica,
        'setSecurePin': value.setSecurePin,
        'domain': value.domain,
        'alias': value.alias,
    };
}
